import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Note, Page } from "../../../helbest";
import { Drawer } from "../../components";
import Content from "../../components/Home/Content/Content";
import { mapEdgesToNodes } from "../../../base/utils";
import { useMeQuery } from "../../../saleor/api";
import { _login_user, set_credit } from "../../../store/actions/login_actions";
import styles from "./Home.module.css";
import useHome from "./useHome";
import CategoryBar from "../../components/Home/CategoryBar/CategoryBar";
import { Button, Modal } from "antd";
import { set_seen } from "../../../store/actions/popup_actions";
import BannerSlider from "../../components/Home/Banner/BannerSlider";
import { useTranslation } from "react-i18next";
import PromoModal from "../../components/PromoModal/PromoModal";
const Home = () => {
  const [show_footer, set_show_footer] = useState(true);
  const [showPopUp, setShowPopUp] = useState(false);
  const { Login, Popup } = useSelector((state) => state);
  const dispatch = useDispatch();
  const { contents } = useHome();
  const hasRunEffect = useRef(false);
  const { t } = useTranslation();

  const { data: profileData } = useMeQuery({
    variables: {},
    skip: !Login.token,
    onError: (err) => {
      Note.error(err.message);
    },
  });

  useEffect(() => {
    if (profileData?.me) {
      const wallet = mapEdgesToNodes(profileData.me.giftCards.edges).find(
        (giftCard) =>
          giftCard.metadata.find(
            (meta) => meta.value.toLowerCase() === "wallet",
          ),
      );
      const credit = wallet?.currentBalance?.amount;
      const walletCode = wallet?.code;
      localStorage.setItem("wallet_code", walletCode);
      dispatch(set_credit(credit));
      dispatch(
        _login_user({
          first_name: profileData?.me?.firstName,
          last_name: profileData?.me?.lastName,
          email: profileData?.me?.email,
          user_id: profileData?.me?.id,
          token: Login.token,
          refreshToken: Login.refreshToken,
          phone_number: Login.phone_number,
          countryCode: Login.country_code,
        }),
      );
    }
    // eslint-disable-next-line
  }, [profileData]);

  useEffect(() => {
    if (!hasRunEffect.current && contents?.length > 0 && !Popup.seenPopup) {
      const popupContent = contents.find((c) => c.title === "popup");
      const imageUrl = popupContent?.banners[0]?.images?.[0]?.url;

      if (imageUrl) {
        setShowPopUp(true);
      }

      hasRunEffect.current = true;
    }
  }, [contents]);

  return (
    <>
      {contents?.filter((c) => c.title === "header")[0]?.banners.length > 0 ? (
        <div className={styles.HeaderContainer}>
          <BannerSlider
            bannerGroup={
              contents?.filter((c) => c.title === "header")[0].banners[0]
            }
            isHeader={true}
          />
        </div>
      ) : null}
      <Page
        cart
        logo
        hasHeader
        customPageClassName={"helbest-page-body-home"}
        className={`page-home ${styles.Home}`}
        drawer={<Drawer />}
        showFooter={show_footer}
      >
        <CategoryBar />
        <PromoModal />

        <Content set_show_footer={set_show_footer} contents={contents} />
      </Page>
      <Modal
        open={showPopUp}
        onCancel={() => {
          dispatch(set_seen());
          setShowPopUp(false);
        }}
        footer={null}
        className={styles.Popup}
        styles={{ content: { padding: "10px" } }}
        closable={false}
      >
        {contents?.filter((c) => c.title === "popup")[0]?.banners[0].images[0]
          .external_url ? (
          <a
            href={
              contents.filter((c) => c.title === "popup")[0].banners[0]
                .images[0].external_url
            }
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={
                contents.filter((c) => c.title === "popup")[0].banners[0]
                  .images[0].url
              }
              alt="PopUp"
            />
          </a>
        ) : (
          <img
            src={
              contents?.filter((c) => c.title === "popup")[0]?.banners[0]
                .images[0].url
            }
            alt="PopUp"
          />
        )}
        <div className="flex justify-center">
          <Button
            type="primary"
            onClick={() => {
              dispatch(set_seen());
              setShowPopUp(false);
            }}
          >
            {t("common.ok")}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default Home;
